/* Gallery Wall - iCanvas Style Theme | theme.js */
(function () {
  'use strict';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  var FAV_KEY = 'gw-favourites';

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initCarousels();
    initHeroAutoplay();
    initNav();
    initDrawer();
    initStickyHeader();
    initGallery();
    initProductForm();
    initAjaxCart();
    initFacets();
    initReadMore();
    initFavorites();
    initChat();
  });

  /* ---------- Announcement bar rotation (arrows + auto) ---------- */
  function initAnnouncement() {
    var slides = $$('.announcement-bar__slide');
    if (slides.length < 1) return;
    var index = 0;
    var timer = null;
    function show(n) {
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === n); });
      index = n;
    }
    function restart() {
      if (timer) clearInterval(timer);
      if (slides.length > 1) timer = setInterval(function () { show((index + 1) % slides.length); }, 5000);
    }
    var prev = $('.announcement-bar__arrow[data-announce-prev]');
    var next = $('.announcement-bar__arrow[data-announce-next]');
    if (prev) prev.addEventListener('click', function () { show((index - 1 + slides.length) % slides.length); restart(); });
    if (next) next.addEventListener('click', function () { show((index + 1) % slides.length); restart(); });
    restart();
  }

  /* ---------- Generic scroll carousels (arrows + page counters) ---------- */
  function initCarousels() {
    $$('[data-carousel-section]').forEach(function (section) {
      var track = $('[data-carousel-track]', section);
      if (!track) return;
      var step = function () { return track.clientWidth * 0.85; };
      var prev = $('[data-carousel-prev]', section);
      var next = $('[data-carousel-next]', section);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });

      var current = $('[data-carousel-current]', section);
      var total = $('[data-carousel-total]', section);
      var panels = track.children;
      if (total) total.textContent = panels.length;
      function updateCurrent() {
        if (!current || !panels.length) return;
        var idx = Math.round(track.scrollLeft / (track.scrollWidth / panels.length));
        current.textContent = Math.min(panels.length, Math.max(1, idx + 1));
      }
      track.addEventListener('scroll', throttle(updateCurrent, 150));
      updateCurrent();

      // Page-based pagination ("1 of 4")
      var pageCurrent = $('[data-carousel-page-current]', section);
      var pageTotal = $('[data-carousel-page-total]', section);
      if (pageCurrent && pageTotal) {
        function pages() { return Math.max(1, Math.ceil(track.scrollWidth / track.clientWidth)); }
        function updatePages() {
          var p = Math.min(pages(), Math.max(1, Math.round(track.scrollLeft / track.clientWidth) + 1));
          pageTotal.textContent = pages();
          pageCurrent.textContent = p;
        }
        $$('[data-carousel-page-prev]', section).forEach(function (b) {
          b.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
        });
        $$('[data-carousel-page-next]', section).forEach(function (b) {
          b.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
        });
        track.addEventListener('scroll', throttle(updatePages, 150));
        window.addEventListener('resize', throttle(updatePages, 200));
        updatePages();
      }
    });
  }

  /* ---------- Hero autoplay + dots ---------- */
  function initHeroAutoplay() {
    $$('[data-hero-autoplay]').forEach(function (hero) {
      var track = $('[data-carousel-track]', hero);
      if (!track || track.children.length < 2) return;
      var slides = Array.prototype.slice.call(track.children);

      // build dots
      var dotsWrap = $('.hero__dots', hero);
      if (!dotsWrap) {
        dotsWrap = document.createElement('div');
        dotsWrap.className = 'hero__dots';
        slides.forEach(function (_, i) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'hero__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
          d.addEventListener('click', function () { goTo(i); restart(); });
          dotsWrap.appendChild(d);
        });
        hero.appendChild(dotsWrap);
      }
      var dots = $$('.hero__dot', dotsWrap);

      function currentIdx() {
        return Math.round(track.scrollLeft / track.clientWidth) % slides.length;
      }
      function goTo(n) {
        track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === n); });
      }
      function restart() {
        if (hero._heroTimer) clearInterval(hero._heroTimer);
        hero._heroTimer = setInterval(function () { goTo((currentIdx() + 1) % slides.length); }, 6000);
      }
      track.addEventListener('scroll', throttle(function () {
        var idx = currentIdx();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, 150));

      // pause on hover
      hero.addEventListener('mouseenter', function () { if (hero._heroTimer) clearInterval(hero._heroTimer); });
      hero.addEventListener('mouseleave', restart);

      // arrows also reset the timer
      var prev = $('[data-carousel-prev]', hero);
      var next = $('[data-carousel-next]', hero);
      if (prev) prev.addEventListener('click', restart);
      if (next) next.addEventListener('click', restart);

      restart();
    });
  }

  function throttle(fn, wait) {
    var last = 0, timer = null;
    return function () {
      var now = Date.now();
      var run = function () { last = now; fn(); };
      if (now - last >= wait) { run(); }
      else { clearTimeout(timer); timer = setTimeout(run, wait); }
    };
  }

  /* ---------- Mega menu (hover via CSS + click toggle) ---------- */
  function initNav() {
    var items = $$('.site-nav__item.has-mega');
    items.forEach(function (item) {
      var btn = $('[data-mega-toggle]', item);
      if (!btn) return;
      btn.addEventListener('click', function () {
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        items.forEach(function (other) {
          if (other !== item) {
            other.classList.remove('is-open');
            var b = $('[data-mega-toggle]', other);
            if (b) b.setAttribute('aria-expanded', 'false');
          }
        });
      });
    });
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.site-nav__item.has-mega')) {
        items.forEach(function (item) {
          item.classList.remove('is-open');
          var b = $('[data-mega-toggle]', item);
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        items.forEach(function (item) { item.classList.remove('is-open'); });
      }
    });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    var drawer = $('#MobileDrawer');
    if (!drawer) return;
    function open() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    $$('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  /* ---------- Sticky header shadow ---------- */
  function initStickyHeader() {
    var header = $('#SiteHeader');
    if (!header) return;
    function onScroll() {
      header.classList.toggle('is-scrolled', window.scrollY > 4);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Product gallery ---------- */
  function initGallery() {
    $$('[data-gallery]').forEach(function (gallery) {
      var slides = $$('.product-gallery__slide', gallery);
      var thumbs = $$('.product-gallery__thumb', gallery);
      var counter = $('.product-gallery__counter-current', gallery);
      function activate(n) {
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === n); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === n); });
        if (counter) counter.textContent = n + 1;
      }
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activate(thumbs.indexOf(thumb));
        });
      });
      var prev = $('.product-gallery__arrow--prev', gallery);
      var next = $('.product-gallery__arrow--next', gallery);
      function go(delta) {
        var active = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        activate((active + delta + slides.length) % slides.length);
      }
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
    });
  }

  /* ---------- Product form: option pills -> variant ---------- */
  function initProductForm() {
    var form = $('#product-form');
    if (!form) return;
    var dataEl = $('[data-variants]', form.closest('.product-page') || document);
    if (!dataEl) return;
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function onPillChange(e) {
      var pill = e.target.closest('.pill');
      if (pill) {
        var wrap = pill.closest('.option__values');
        $$('.pill', wrap).forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        var label = pill.closest('.option').querySelector('[data-selected]');
        if (label) label.textContent = e.target.value;
      }
      var checked = $$('[data-option-selector]:checked', form);
      var selected = checked.map(function (i) { return i.value; });
      var match = variants.find(function (v) {
        return v.options.length === selected.length && v.options.every(function (o, i) { return o === selected[i]; });
      });
      if (!match) return;
      var idInput = $('[data-variant-id]', form);
      if (idInput) idInput.value = match.id;
      var priceEl = $('[data-price]', form);
      if (priceEl) priceEl.textContent = formatMoney(match.price);
      var compareEl = $('[data-compare]', form);
      if (compareEl) {
        compareEl.textContent = match.compare_at_price > match.price ? formatMoney(match.compare_at_price) : '';
        compareEl.style.display = match.compare_at_price > match.price ? '' : 'none';
      }
      var offEl = $('[data-off-badge]', form);
      if (offEl) {
        var showOff = match.compare_at_price > match.price;
        if (showOff) {
          var off = Math.round(100 - (match.price / match.compare_at_price) * 100);
          offEl.textContent = off + '% OFF';
          offEl.style.display = '';
        } else {
          offEl.style.display = 'none';
        }
      }
      var add = $('[data-add-button]', form);
      if (add) add.disabled = !match.available;
      if (match.featured_media && typeof match.featured_media.id !== 'undefined') {
        var gallery = $('[data-gallery]');
        if (gallery) {
          var slides = $$('.product-gallery__slide', gallery);
          var idx = slides.findIndex(function (s) {
            var img = $('img', s);
            return img && (img.dataset.mediaId == match.featured_media.id);
          });
          if (idx > -1) {
            slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
            var thumbs = $$('.product-gallery__thumb', gallery);
            thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
          }
        }
      }
    }
    form.addEventListener('change', onPillChange);
  }

  /* ---------- Toast helper ---------- */
  var toastTimer = null;
  function showToast(message) {
    var toast = $('#GwToast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'GwToast';
      toast.className = 'toast';
      document.body.appendChild(toast);
    }
    toast.innerHTML = '<svg class="icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="m4.5 12.5 5 5 10-11"/></svg><span></span>';
    toast.querySelector('span').textContent = message;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    if (toastTimer) clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-visible'); }, 2800);
  }

  /* ---------- AJAX add to cart ---------- */
  function initAjaxCart() {
    var form = $('#product-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var add = $('[data-add-button]', form);
      if (add) { add.disabled = true; add.dataset.label = add.textContent; }
      var formData = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function (item) {
          if (item.status) throw new Error(item.description || 'Unable to add to cart');
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          var count = $$('[data-cart-count]');
          count.forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.toggle('is-empty', cart.item_count === 0);
          });
          showToast('Added to cart — ' + (cart.item_count === 1 ? '1 item' : cart.item_count + ' items'));
          if (add) { add.disabled = false; add.textContent = add.dataset.label || 'Add to Cart'; }
        })
        .catch(function (err) {
          showToast(err.message || 'Something went wrong');
          if (add) { add.disabled = false; add.textContent = add.dataset.label || 'Add to Cart'; }
        });
    });
  }

  /* ---------- Collection facets: auto-submit ---------- */
  function initFacets() {
    var form = $('#FacetForm');
    if (!form) return;
    $$('input[type="checkbox"]', form).forEach(function (input) {
      input.addEventListener('change', function () { form.submit(); });
    });
    var sort = $('[data-sort-select]');
    if (sort) {
      sort.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sort.value);
        window.location.href = url.href;
      });
    }
  }

  /* ---------- Read more toggle ---------- */
  function initReadMore() {
    var btn = $('[data-readmore-btn]');
    if (!btn) return;
    var body = $('[data-readmore-body]');
    btn.addEventListener('click', function () {
      var collapsed = body.classList.toggle('is-collapsed');
      btn.textContent = collapsed ? 'read more' : 'read less';
    });
  }

  /* ---------- Favourite hearts (persisted in localStorage) ---------- */
  function getFavs() {
    try { return JSON.parse(localStorage.getItem(FAV_KEY) || '[]'); } catch (e) { return []; }
  }
  function setFavs(arr) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(arr)); } catch (e) { /* ignore */ }
  }
  function initFavorites() {
    var favs = getFavs();
    $$('.product-card__fav, .product-gallery__fav').forEach(function (btn) {
      var id = btn.getAttribute('data-fav-id');
      if (id && favs.indexOf(id) > -1) {
        btn.classList.add('is-faved');
        btn.style.opacity = '1';
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var faved = btn.classList.toggle('is-faved');
        btn.style.opacity = faved ? '1' : '';
        var fid = btn.getAttribute('data-fav-id');
        if (fid) {
          var list = getFavs();
          if (faved && list.indexOf(fid) === -1) list.push(fid);
          if (!faved) list = list.filter(function (x) { return x !== fid; });
          setFavs(list);
        }
        showToast(faved ? 'Saved to favourites' : 'Removed from favourites');
      });
    });
  }

  /* ---------- Floating chat ---------- */
  function initChat() {
    var fab = $('#ChatFab');
    var panel = $('#ChatPanel');
    if (!fab || !panel) return;
    fab.addEventListener('click', function () {
      panel.classList.toggle('is-open');
    });
    var close = $('[data-chat-close]', panel);
    if (close) close.addEventListener('click', function () { panel.classList.remove('is-open'); });
  }
})();
